"use strict";

function FormSchemaService(DOM) {
	var schema = {},
		structure = {} ;

	DOM.addEventListener('register-schema', function (e) {
		registerSchema(DOM.qbe);
	}, false);

	function registerSchema(conf) {
		schema = conf.formSchema;
		structure = conf.formStructure;
	}
	
	function extractGroup(groupName, param) {
		var field = structure[groupName] ;
		if ( ! field )
			throw groupName + ' does not exist in the form structure';
		else if ( typeof(field) == 'string' )
			return extractGroup(field) ; 

		return structure[groupName] ; 
	}

	function extractField(fieldName) {
		var field = schema[fieldName];
		if ( ! field )
			throw fieldName + ' does not exist in the form schema/structure';
		return field;
	}
	
	function getGenericValidationMessageFor(rule) {
		return 'generic error message' ; 
	}

	return {
		extractGroup: extractGroup,
		extractField: extractField,
		getGenericValidationMessageFor: getGenericValidationMessageFor,
	};
}
